import * as actions from './metaWhatsAppConfig.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ExtMetaWhatsAppConfigModel } from '@smarttask-common/src/lib/models/Integrations/Meta/WhatsApp/ExtMetaWhatsAppConfigModel';

export const configAdapter = createEntityAdapter<ExtMetaWhatsAppConfigModel>({
    selectId: (x) => x.user.user_id,
});
export interface MetaWhatsAppConfigState extends EntityState<ExtMetaWhatsAppConfigModel> {
    selected_user_id: number;
}

export const initialState: MetaWhatsAppConfigState = configAdapter.getInitialState({
    selected_user_id: undefined,
});

export function MetaWhatsAppConfigReducers(state: MetaWhatsAppConfigState = initialState, action: actions.MetaWhatsAppConfigActions) {
    switch (action.type) {
        case actions.MetaWhatsAppConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_user_id: action.selected_user_id };
            return state;

        case actions.MetaWhatsAppConfigActionTypes.ADD_META_WA_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.MetaWhatsAppConfigActionTypes.ADD_META_WA_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.MetaWhatsAppConfigActionTypes.UPSERT_META_WA_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.MetaWhatsAppConfigActionTypes.UPSERT_META_WA_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.MetaWhatsAppConfigActionTypes.UPDATE_META_WA_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.MetaWhatsAppConfigActionTypes.UPDATE_META_WA_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.MetaWhatsAppConfigActionTypes.DELETE_META_WA_CONFIG:
            return configAdapter.removeOne(action.user_id, state);

        case actions.MetaWhatsAppConfigActionTypes.DELETE_META_WA_CONFIGS:
            return configAdapter.removeMany(action.user_ids, state);

        case actions.MetaWhatsAppConfigActionTypes.DELETE_ALL_META_WA_CONFIGS:
            return configAdapter.removeMany(action.user_ids, state);

        case actions.MetaWhatsAppConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getMetaWhatsAppConfigState = createFeatureSelector<MetaWhatsAppConfigState>('metaWhatsAppConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getMetaWhatsAppConfigState);

const getSelectedConfigIdState = (state: MetaWhatsAppConfigState) => {
    return state.selected_user_id;
};
export const getSelectedConfigId = createSelector(getMetaWhatsAppConfigState, getSelectedConfigIdState);

export const getSelectedConfig = createSelector(getMetaWhatsAppConfigState, (state: MetaWhatsAppConfigState) => {
    if (state.selected_user_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_user_id];
});
